SEARCH_DISCLOSURE = {
    messages: {
        VOIR_PLUS: "Show more",
        VOIR_MOINS: "Show less"
    }
};
